import React, { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { Toaster } from "react-hot-toast";
import { Link } from "react-router-dom";
import { RenameFolder } from "./RenameFolder";
import DeleteFolderAlert from "./RecycleBin/DeleteFolderAlert";
import FileBg from "../generators/fileBGGenerator";

// images from public folder
const ThreeDots = `${process.env.PUBLIC_URL}/assets/threedots.webp`;
const FolderImg = `${process.env.PUBLIC_URL}/assets/folder.webp`;

const FALLBACK_FOLDER_COLOR = "#5E5ADB";

// Same hex -> rgba conversion FilesGridPage uses for file cards, kept local
// here so folder cards can pick up the identical tinted-background look
// without file cards and folder cards silently drifting apart over time.
const hexToRgba = (hex, alpha) => {
  let r = 0,
    g = 0,
    b = 0;

  if (!hex) return `rgba(0, 0, 0, ${alpha})`;

  if (hex.length === 4) {
    r = parseInt(hex[1] + hex[1], 16);
    g = parseInt(hex[2] + hex[2], 16);
    b = parseInt(hex[3] + hex[3], 16);
  } else if (hex.length === 7) {
    r = parseInt(hex[1] + hex[2], 16);
    g = parseInt(hex[3] + hex[4], 16);
    b = parseInt(hex[5] + hex[6], 16);
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const OwnedFolders = ({ folders, listFolders, deptColor, deptId }) => {
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedFolder, setSelectedFolder] = useState(null);
  const [folder, setFolder] = useState({});
  const [anchorEls, setAnchorEls] = useState({}); // Separate state for anchorEls

  const handleMenuClick = (event, folder) => {
    setAnchorEls((prevAnchorEls) => ({
      ...prevAnchorEls,
      [folder.id]: event.currentTarget,
    }));
    setFolder(folder);
  };

  const handleClose = (folderId) => {
    setAnchorEls((prevAnchorEls) => ({
      ...prevAnchorEls,
      [folderId]: null,
    }));
  };

  return (
    <div className="mt-2">
      <Toaster position="bottom-left" reverseOrder={false} />
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 ">
        {folders &&
          folders.map((folder) => {
            // A folder's own saved color wins (e.g. custom-picked), then
            // the department it belongs to, then a neutral fallback for
            // unscoped/dashboard folders — mirrors how file cards resolve
            // their color in FilesGridPage.
            const color =
              folder.metadata?.bg || deptColor || FALLBACK_FOLDER_COLOR;
            const backgroundColor = hexToRgba(color, 0.12);

            return (
              <div
                key={folder.id}
                style={{
                  backgroundColor,
                  backgroundImage: FileBg({
                    gradientColors: [color, color, color, color],
                  }),
                  backgroundSize: "cover",
                  backgroundPosition: "center center",
                  backgroundRepeat: "no-repeat",
                  backgroundBlendMode: "lighten",
                  borderColor: hexToRgba(color, 0.35),
                }}
                className="border rounded-2xl cursor-pointer flex-shrink-0 mr-4"
              >
                <div>
                  <Link
                    className="flex justify-center items-center py-4 px-8"
                    to={`/filesInsideFolder/${folder.name}/${folder.id}`}
                    state={{ deptId: deptId }}
                  >
                    <img
                      alt="folder img"
                      className="h-24 w-24"
                      src={FolderImg}
                    />
                  </Link>
                </div>
                <span className="flex flex-row justify-between items-center line-clamp-1 ">
                  <p className="px-4 pb-2 line-clamp-1 font-semibold text-md">
                    {folder.name}
                  </p>
                  <span>
                    <button
                      className="mx-2"
                      onClick={(event) => handleMenuClick(event, folder)}
                    >
                      <img src={ThreeDots} height={25} width={25} alt="" />
                    </button>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEls[folder.id]}
                      open={Boolean(anchorEls[folder.id])}
                      onClose={() => handleClose(folder.id)}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                      PaperProps={{
                        style: {
                          border: "1px solid [#11182626]",
                          boxShadow: "0px 2px 3px rgba(0, 0, 0, 0.1)",
                          borderRadius: "6px",
                        },
                      }}
                    >
                      <MenuItem
                        onClick={() => {
                          setSelectedFolder(folder);

                          handleClose(folder.id);

                          setTimeout(() => {
                            setDeleteDialogOpen(true);
                          }, 100);
                        }}
                      >
                        Delete
                      </MenuItem>
                      <MenuItem style={{ padding: "0px 10px" }}>
                        <RenameFolder folder={folder} />
                      </MenuItem>
                    </Menu>
                  </span>
                </span>
              </div>
            );
          })}

        {selectedFolder && (
          <DeleteFolderAlert
            open={deleteDialogOpen}
            onClose={() => setDeleteDialogOpen(false)}
            id={selectedFolder.id}
            folderName={selectedFolder.name}
            owner={selectedFolder.owner}
            onRecycled={() => {
              listFolders();
              setDeleteDialogOpen(false);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default OwnedFolders;
